import React from 'react';
import { useValidate, useValidator } from 'react-admin-base';
import { FormattedMessage } from "react-intl";
import { Alert, FormFeedback } from "reactstrap";
function ValidatorCore(name, value, type, children) {
    const error = useValidate(name || '', value, type);
    return React.createElement(React.Fragment, null,
        (error
            && React.cloneElement(children, { invalid: !!error, className: (children.props.className || '') + (!!error ? ' is-invalid' : '') })) || children,
        error && React.createElement(FormFeedback, { className: "d-block" }, error));
}
export function Validator({ name, type, children }) {
    return ValidatorCore(name, children.props.value || children.props.checked, type, children);
}
export function ValueValidator({ name, value, type, children }) {
    return ValidatorCore(name, value, type, children);
}
export function ValidationErrors() {
    const validator = useValidator();
    if (validator.messagesShown) {
        let errors = Object.values(validator.getErrorMessages()).filter(a => !!a);
        if (!!errors.length) {
            return React.createElement(Alert, { color: "danger", toggle: () => validator.hideMessages() },
                React.createElement("p", null,
                    React.createElement("i", { className: "fas fa-exclamation-circle" }),
                    " ",
                    React.createElement("b", null,
                        React.createElement(FormattedMessage, { id: "VALIDATION.ERROR" }))),
                React.createElement("ol", { className: "mb-0" }, errors.map(value => React.createElement("li", null, value))));
        }
    }
    return null;
}
